import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BentoModule } from '@bento/bento-ng';
import { BentoTransferboxModule } from '@bento/bento-ng-transferbox';
import { BentoFlexGridControlModule } from '@bento/bento-ng-flexgrid-control';
import { SharedModule } from 'src/app/shared/shared.module';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter';
import { WjGridGrouppanelModule } from '@grapecity/wijmo.angular2.grid.grouppanel';
import { WjGridSearchModule } from '@grapecity/wijmo.angular2.grid.search';
import { WjGaugeModule } from '@grapecity/wijmo.angular2.gauge';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BentoD3Module } from '@bento/bento-ng-d3';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EventsAdministrationBaseComponent } from './components/events-administration-base/events-administration-base.component';
import { ShowAllEventsComponent } from './components/show-all-events/show-all-events.component';
import { RegistrationPageComponent } from '../gfr-events-administration/components/registration-page/registration-page.component';
import { SchemaBrowserComponent } from './components/schema-browser/schema-browser.component';
import { NoEventsComponent } from './components/no-events/no-events.component';
import { GfrEventsAdministrationRoutingModule } from './gfr-events-administration-routing.module';
import { EventsAdminService } from './services/events-admin.service';

@NgModule({
  declarations: [
    EventsAdministrationBaseComponent, 
    ShowAllEventsComponent,
    RegistrationPageComponent,  
    SchemaBrowserComponent, 
    NoEventsComponent
  ],
  imports: [
    BentoModule,
    BentoD3Module,
    BentoTransferboxModule,
    BentoFlexGridControlModule,
    CommonModule,
    NgbModule,
    ReactiveFormsModule,
    SharedModule,
    FormsModule,
    WjGridModule,
    WjInputModule,
    WjGridFilterModule,
    WjGridGrouppanelModule,
    WjGridSearchModule,
    WjGaugeModule,    
    GfrEventsAdministrationRoutingModule
  ],
  providers: [EventsAdminService]
})
export class GfrEventsAdministrationModule { }
